import $ from "jquery";
import fetch from "mojave/polyfill/fetch";


export class GuardedRemove
{
	/**
	 *
	 */
	init ()
	{
		$("button[data-guarded-remove]")
			.on("click", (event) => this.onClick(event));
	}


	/**
	 * @private
	 * @param {Event} event
	 */
	onClick (event)
	{
		const $button = $(event.currentTarget);
		const url = $button.data("guarded-remove");
		const title = $button.attr("data-original-title") || $button.attr("title");

		const $modal = $(`
			<div class="modal" tabindex="-1" role="dialog">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Eintrag löschen?</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<p>Soll dieser Eintrag wirklich gelöscht werden? Dies kann nicht rückgängig gemacht werden.</p>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-danger" data-proceed>Löschen</button>
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>
						</div>
					</div>
				</div>
			</div>
		`);

		// update title if necessary
		if (null !== title)
		{
			$modal.find(".modal-title").text(title);
		}

		// register event listeners and interaction
		// eslint-disable-next-line new-cap
		const promise = $.Deferred();
		$modal
			.on("click", "button[data-proceed]", () => this.proceedWithModal($modal, url))
			.on("hide.bs.modal", () => promise.resolve(false))
			.on("hidden.bs.modal", () =>
			{
				$modal.modal("dispose");
				$modal.remove();
			});

		// display modal
		$modal.appendTo(document.body);
		$modal.modal({
			backdrop: 'static', keyboard: false,
		});
	}


	/**
	 * Handles the click on the "proceed" link
	 *
	 * @param {JQuery} $modal
	 * @param {string} url
	 */
	proceedWithModal ($modal, url)
	{
		const $content = $modal.find(".modal-body");
		const $buttons = $modal.find("button");

		$content.html(`
			<p>Eintrag wird gelöscht...</p>
			<div class="progress">
				<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
			</div>
		`);

		$buttons.attr("disabled", true);

		fetch(url, {
			method: "post", credentials: "include", cache: "no-cache",
		})
			.then(response => response.json())
			.then((data) =>
			{
				if (data.status === "ok")
				{
					$modal.modal("hide");
					document.location.reload(true);
					return;
				}

				let message = (data.status === "error" && data.message !== undefined)
					? `<strong>Das Löschen ist leider fehlgeschlagen:</strong><br>${data.message}`
					: "Das Löschen ist leider fehlgeschlagen. Bitte laden Sie die Seite neu und versuchen es erneut";

				$buttons.attr("disabled", false);
				$content.html(`<div class="alert alert-danger" role="alert">${message}</div>`);
				$modal.find("button[data-proceed]").remove();
			}, () =>
			{
				$buttons.attr("disabled", false);
				$content.html(`<div class="alert alert-danger" role="alert">Das Löschen ist leider fehlgeschlagen. Bitte laden Sie die Seite neu und versuchen es erneut.</div>`);
			});
	}
}
